import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 10vh;
`;

const Content = styled.div`
  max-width: 100%;
  margin-top: ${({ isConnected, screenWidth }) => {
    if (screenWidth >= 992) {
      return '0';
    }
    return isConnected ? '0px' : '88px';
  }};
`;

export { Content };

export default Container;
